import { validateInn } from '@alfa-bank/site-form-helpers/validation/inn';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import type { TInputType } from '@alfa-bank/site-input/models';

import type { TValidators } from '../models';

export const validators = {
    inn: validateInn,
    required: validateNotEmpty,
};

export const patterns = {
    positiveNumber: '^\\d+$',
};

const primitiveTypes = ['text', 'tel', 'number', 'phone', 'hidden', 'email'];

/**
 * Достает валидатор по ключу
 *
 * @param key - ключ валидатора
 */
export const getValidator = (key: TValidators['value']) => validators[key] ?? (() => () => {});

/**
 * Достает регулярку по типу инпута
 *
 * @param type - тип инпута
 */
export const getPatternByType = (type = '') => patterns[type as keyof typeof patterns];

/**
 * Возвращает примитивный тип для инпута
 *
 * @param type - тип инпута
 */
export const getPrimitiveType = (type = '') =>
    primitiveTypes.includes(type) ? (type as TInputType) : 'text';

/**
 * Проверка значения инпута на корректность. Значение корректно, если:
 * 1) Оно пустое
 * 2) Непустое, но регулярка не установлена
 * 3) Непустое и соответствует регулярке
 *
 * @param value - значение, если есть
 * @param regExp - регурное выражение, если есть
 */
export const checkValue = (value?: string, regExp?: string) =>
    !value || !regExp || new RegExp(regExp).test(value);
